import React from 'react';
import { Button } from 'primereact/button';
import useVehicleWarrantyClaimsReportSum from './hooks/useVehicleWarrantyClaimsReportSum';
import VehicleWarrantyClaimsReportSumTable from './components/VehicleWarrantyClaimsReportSumTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportVehicleWarrantyClaimsReportSumToExcelQuery } from '../../../api/endpoints/vehicleWarrantyClaimsReportSum';

const VehicleWarrantyClaimsReportSumPage = () => {
    const { th } = useLanguage();

    const { apiData, isLoading, lazyParams, sortField, sortOrder, activeFilters, exportParams, onPage, onSort, handleFilterChange, initFilters } = useVehicleWarrantyClaimsReportSum();

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleWarrantyClaimsReportSum.title')}</h1>
                <div className="flex gap-2">
                    <Button icon="pi pi-filter-slash" className="p-button-outlined p-button-secondary" onClick={initFilters} tooltip={th('filter.reset')} tooltipOptions={{ position: 'left' }} />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportVehicleWarrantyClaimsReportSumToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel={th('common.export')}
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        fileNameExtractor={(result) => result?.fileName || 'garanti_talepleri_ozet.xlsx'}
                        dataExtractor={(result) => result?.fileBase64}
                        contentTypeExtractor={(result) => result?.contentType}
                    />
                </div>
            </div>

            <VehicleWarrantyClaimsReportSumTable
                items={apiData?.items}
                totalCount={apiData?.totalCount}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />
        </div>
    );
};

export default VehicleWarrantyClaimsReportSumPage;
